import { render, staticRenderFns } from "./grantsList.vue?vue&type=template&id=3496cb76&"
import script from "./grantsList.vue?vue&type=script&lang=js&"
export * from "./grantsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports